import React from "react";
import { Mail, MapPin, Phone } from "lucide-react";

export function ContactInfo() {
  return (
    <div className="bg-white/5 rounded-xl p-8">
      <h2 className="text-xl font-bold text-white mb-6">Contact Information</h2>
      <div className="space-y-6">
        <div className="flex items-start">
          <Mail className="h-5 w-5 text-volt-blue mr-3 flex-shrink-0 mt-0.5" />
          <div>
            <h3 className="text-sm font-medium text-gray-300">Email</h3>
            <a
              href="mailto:support@voltblocks.com"
              className="text-white hover:text-volt-blue transition-colors"
            >
              support@voltblocks.com
            </a>
          </div>
        </div>

        <div className="flex items-start">
          <Phone className="h-5 w-5 text-volt-blue mr-3 flex-shrink-0 mt-0.5" />
          <div>
            <h3 className="text-sm font-medium text-gray-300">Phone</h3>
            <a
              href="tel:+1-555-123-4567"
              className="text-white hover:text-volt-blue transition-colors"
            >
              +1 (555) 123-4567
            </a>
          </div>
        </div>

        <div className="flex items-start">
          <MapPin className="h-5 w-5 text-volt-blue mr-3 flex-shrink-0 mt-0.5" />
          <div>
            <h3 className="text-sm font-medium text-gray-300">Office</h3>
            <p className="text-white">
              123 Block Street
              <br />
              San Francisco, CA 94107
              <br />
              United States
            </p>
          </div>
        </div>
      </div>

      <div className="mt-8 pt-8 border-t border-gray-700">
        <h3 className="text-sm font-medium text-gray-300 mb-4">
          Business Hours
        </h3>
        <div className="space-y-2">
          <div className="flex justify-between">
            <span className="text-gray-400">Monday - Friday:</span>
            <span className="text-white">9:00 AM - 6:00 PM PST</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-400">Saturday:</span>
            <span className="text-white">10:00 AM - 4:00 PM PST</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-400">Sunday:</span>
            <span className="text-white">Closed</span>
          </div>
        </div>
      </div>
    </div>
  );
}
